<template>
    <div
        class="toastification"
        :class="`bg-${variant}`"
    >
        <div class="d-flex align-items-start">
            <b-avatar
                v-if="icon"
                size="1.8rem"
                class="mr-75 flex-shrink-0"
            >
                <feather-icon
                    :icon="icon"
                    size="15"
                />
            </b-avatar>
            <div class="d-flex flex-grow-1">
                <div>
                    <h5
                        v-if="title"
                        class="mb-0 text-white toastification-title"
                        v-text="title"
                    />
                    <small
                        v-if="text"
                        class="d-inline-block text-body"
                        v-text="text"
                    />
                </div>
                <span
                    class="cursor-pointer toastification-close-icon ml-auto "
                    @click="$emit('close-toast')"
                >
                    <feather-icon
                        v-if="!hideClose"
                        icon="XIcon"
                        class="text-body"
                    />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
    components: {
        BAvatar
    },
    props: {
        variant: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        hideClose: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.Vue-Toastification__toast .toastification {
    padding: 15px 20px !important;
}
// .toastification-close-icon,
// .toastification-title {
//     line-height: 0;
// // }
// .toastification-title {
//     color: inherit;
// }
</style>
<style lang="scss">
.my-toast.Vue-Toastification__toast {
    width: 395px !important;
    padding: 0rem !important;
    top: 67px !important;
    right: 22% !important;
    @media (max-width: 1777px) {
        right: 3% !important;
    }
    @media (max-width: 600px) {
        width: 100px !important;
        left: 3% !important;
    }
}
</style>
